<!--
 * @Description : 换绑手机号码
 * @Author      : pishengjun
 * @Date        : 2022-11-22 14:11:53
-->
<template>
  <a-modal v-model:open="myVisible" :title="null" :keyboard="false" :maskClosable="false" :footer="null" width="480px">
    <div class="changeBox" @click.self="onFocus">
      <div class="title" @click.self="onFocus">换绑手机号码</div>
      <a-form :model="formState" name="basic" autocomplete="off" class="myForm" @finish="onFinish" @click.stop="onFocus">
        <div class="oldPhone">
          <span class="oldPhoneTxt" @click.self="onFocus">已绑定手机号： {{ telNumberShow(formState.oldPhone) }}</span>
          <div class="mySendSms">
            <sendPhonecode :phone="formState.oldPhone" :type="3" />
          </div>
        </div>
        <a-form-item name="oldPhoneCode" :rules="[{ required: true, message: '请输入旧手机号码收到的短信验证码！' }]">
          <a-input v-model:value="formState.oldPhoneCode" class="h-50" placeholder="请输入旧手机号码收到的短信验证码" :maxlength="6" @click.stop="onFocus">
            <template #prefix>
              <img src="@/assets/images/yanzhengma.png" />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item name="newPhone" :rules="[{ required: true, message: '请输入手机号码!' }, { validator: validator.validatePhone }]" class="phoneItem">
          <a-input v-model:value="formState.newPhone" class="h-50" placeholder="请输入新手机号码" :maxlength="11" @click="onFocus">
            <template #prefix>
              <img src="@/assets/images/shoujihaoma.png" />
            </template>
            <template #suffix>
              <sendPhonecode :phone="formState.newPhone" :type="3" />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item name="newPhoneCode" :rules="[{ required: true, message: '请输入新手机号码收到的短信验证码!' }]">
          <a-input v-model:value="formState.newPhoneCode" class="h-50" placeholder="请输入新手机号码收到的短信验证码" :maxlength="6" @click="onFocus">
            <template #prefix>
              <img src="@/assets/images/yanzhengma.png" />
            </template>
          </a-input>
        </a-form-item>
        <!-- 提交按钮 -->
        <a-form-item>
          <a-button type="primary" class="h-50 btn" block html-type="submit">确定修改</a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRefs, onMounted } from "vue";
import sendPhonecode from "@/components/sendPhonecode/index.vue";
import { user } from "@/http/api";
import { notification } from "ant-design-vue";
import { validator } from "@/utils/validator";
import { Base64 } from "js-base64";
import { store } from "@/store";
import { useRoute } from "vue-router";

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  components: { sendPhonecode },
  emit: ["update:open"],
  setup(props, { emit }) {
    const query:any = useRoute().query;
    onMounted(() => {
      state.formState.oldPhone = store.state.currentRegisterUser.contactNumber;
    });
    const state = reactive({
      isHiddenSms: false,
      formState: {
        oldPhone: "",
        oldPhoneCode: "",
        newPhone: "",
        newPhoneCode: "",
      },
    });
    const event = {
      onFinish() {
        const { oldPhone, oldPhoneCode, newPhone, newPhoneCode } = state.formState;
        const data = {
          oldPhone: Base64.encode(oldPhone),
          oldPhoneCode: Base64.encode(oldPhoneCode),
          newPhone: Base64.encode(newPhone),
          newPhoneCode: Base64.encode(newPhoneCode),
        };
        user.Authentication.PATCH.changePhone(data,query.id).then(() => {
          notification.success({ message: "操作成功", description: "换绑手机操作成功" });
          event.close();
        });
      },
      // 手机号隐藏中间4位数
      telNumberShow: (cellValue) => {
        if (Number(cellValue) && String(cellValue).length === 11) {
          var mobile = String(cellValue);
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          return mobile.replace(reg, "$1****$2");
        } else {
          return cellValue;
        }
      },
      // 关闭弹窗
      close() {
        emit("update:open", false);
      },
      // 输入框获取焦点时隐藏发送验证码的弹窗验证码区域
      onFocus() {
        state.isHiddenSms = !state.isHiddenSms;
      },
    };
    const myVisible = computed({
      get: () => props.open === true,
      set: (bool: boolean) => emit("update:open", bool),
    });

    return {
      ...toRefs(state),
      ...event,
      myVisible,
      validator,
    };
  },
});
</script>

<style lang="less" scoped>
.changeBox {
  .h-50 {
    height: 50px;
  }
  .title {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin: 10px 20px;
  }
  .oldPhone {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
    position: relative;
    z-index: 4;
    .oldPhoneTxt {
      font-size: 16px;
      font-weight: bold;
    }
    .mySendSms {
      position: relative;
    }
  }
  .myForm {
    margin: 30px 20px;
    .btn {
      font-size: 16px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .phoneItem {
      position: relative;
      z-index: 3;
    }
  }
}
</style>
